<template>
  
  <div>

    <div class=" w-56 bg-medalertBlue text-white h-screen py-8" >

      <div v-if="!user" class="">
          <router-link to="/"><img src="../assets/images/medremindLogoNewWhite2.png" alt="MedAlert Logo" class="mx-4 w-5/6 h-auto sm:h-8 cursor-pointer"></router-link>
      </div>

      <div v-else>
          <router-link to="/dashboard"><img src="../assets/images/medremindLogoNewWhite2.png" alt="MedAlert Logo" class="mx-4 w-5/6 h-auto sm:h-8 cursor-pointer"></router-link>
      </div>

      <ul class="pl-4 pt-10 ">

        <li class="my-2">
           <router-link active-class="bg-white w-full my-4  py-1 pl-1 rounded-l-lg text-medalertBlue flex flex-row" to="/dashboard"> 
            <div class="flex items-center  font-poppins hover:bg-white py-1 rounded-l-lg  pl-1 hover:text-medalertBlue cursor-pointer transition duration-300 ease-in-out">
              <i class="ri-dashboard-line  text-2xl "></i>
              <span class="mx-6 font-medium">Dashboard</span>
           </div>
           </router-link>
        </li>


         <li class="my-2">
           <router-link active-class="bg-white w-full my-4  py-1 pl-1 rounded-l-lg text-medalertBlue flex flex-row   " to="/reminders"> 
            <div class="flex items-center align-middle  font-poppins hover:bg-white py-1 rounded-l-lg  pl-1 hover:text-medalertBlue cursor-pointer transition duration-300 ease-in-out">
              <i class="ri-alarm-line text-2xl "></i>
              <span class="mx-6 font-medium">Reminders</span>
           </div>
           </router-link>
        </li>


         <li class="my-2">
           <router-link active-class="bg-white w-full my-4  py-1 pl-1 rounded-l-lg text-medalertBlue flex flex-row   " to="/account"> 
            <div class="flex items-center align-middle  font-poppins hover:bg-white py-1 rounded-l-lg  pl-1 hover:text-medalertBlue cursor-pointer transition duration-300 ease-in-out">
              <i class="ri-user-line text-2xl"></i>
              <span class="mx-6 font-medium">Account</span>
           </div>
           </router-link>
        </li>


        <li class="my-2" >
           <router-link active-class="bg-white w-full my-4  py-1 pl-1 rounded-l-lg text-medalertBlue flex flex-row   " to="/settings"> 
            <div class="flex items-center align-middle  font-poppins hover:bg-white py-1 rounded-l-lg  pl-1 hover:text-medalertBlue cursor-pointer transition duration-300 ease-in-out">
              <i class="ri-settings-4-line text-2xl"></i>
              <span class="mx-6 font-medium">Settings</span>
           </div>
           </router-link>
        </li>

        

        <li @click.prevent="handleLogout" class="flex items-center font-poppins my-2  py-1 pl-1  hover:bg-white rounded-l-lg hover:text-medalertBlue cursor-pointer transition duration-300 ease-in-out">
              <i class="ri-logout-circle-line text-2xl "></i> 
            <span class="mx-6 font-medium">Log Out</span> 
            
        </li>
      </ul>
    </div>

  </div>
</template>

<script>

import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default {

  name:'sideBar',

 setup(){
    const router = useRouter()
    const store = useStore()
    const user = store.state.user

    const handleLogout = () =>{
      store.dispatch("logout");
    }

    return{
      user,
      handleLogout,
    }
 }


}
</script>

<style>


</style>